<template>
  <div class="min-h-screen bg-gradient-to-br from-slate-50 via-white to-sky-50">
    <div class="mx-auto flex min-h-screen max-w-6xl items-center px-4 py-10">
      <div class="grid w-full gap-8 lg:grid-cols-2">
        <div class="hidden flex-col justify-center lg:flex">
          <div class="inline-flex items-center gap-2 rounded-full bg-white/70 px-3 py-1 text-xs font-semibold text-slate-700 ring-1 ring-slate-200">
            Parking Management System
            <span class="h-1.5 w-1.5 rounded-full bg-emerald-500"></span>
            <!-- Offline (Persisted) -->
          </div>
          <h1 class="mt-4 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            Admin + Gate Operator
            <span class="text-sky-600">Dashboard</span>
          </h1>
          <!-- <p class="mt-3 max-w-xl text-sm leading-6 text-slate-600">
            This demo stores all data locally (persisted state). No backend for now.
          </p> -->

          <div class="mt-6 grid gap-3 sm:grid-cols-2">
            <div class="rounded-xl bg-white p-4 ring-1 ring-slate-200">
              <div class="text-xs font-semibold text-slate-700">Role-based access</div>
              <div class="mt-2 text-xs text-slate-600">
                Separate <span class="font-semibold text-slate-900">Admin</span> and
                <span class="font-semibold text-slate-900">Gate Operator</span> panels with secure login and audit logs.
              </div>
            </div>
            <div class="rounded-xl bg-white p-4 ring-1 ring-slate-200">
              <div class="text-xs font-semibold text-slate-700">Real-time parking & billing</div>
              <div class="mt-2 text-xs text-slate-600">
                Live active vehicles, automatic guest fee calculation, instant receipts, and revenue reports.
              </div>
            </div>
          </div>
        </div>

        <div class="flex items-center justify-center">
          <div class="w-full max-w-md rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
            <div class="flex items-center justify-between">
              <div>
                <div class="text-sm font-semibold text-slate-900">Log in</div>
               
              </div>
              <div class="rounded-full bg-sky-50 px-3 py-1 text-xs font-semibold text-sky-700 ring-1 ring-sky-200">
                Abima Software Solutions
              </div>
            </div>

            <form class="mt-5 space-y-4" @submit.prevent="onSubmit">
              <div>
                <label class="text-xs font-semibold text-slate-700">Username</label>
                <input
                  v-model.trim="username"
                  class="mt-1 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm outline-none ring-sky-200 focus:ring-4"
                  placeholder="Username"
                  autocomplete="username"
                />
              </div>
              <div>
                <label class="text-xs font-semibold text-slate-700">Password</label>
                <input
                  v-model="password"
                  type="password"
                  class="mt-1 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm outline-none ring-sky-200 focus:ring-4"
                  placeholder="Password"
                  autocomplete="current-password"
                />
              </div>

              <button
                type="submit"
                class="w-full rounded-lg bg-sky-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-sky-500 disabled:cursor-not-allowed disabled:opacity-60"
                :disabled="busy"
              >
                {{ busy ? "Signing in..." : "Sign in" }}
              </button>

              <div class="rounded-lg bg-slate-50 p-3 text-xs text-slate-600 ring-1 ring-slate-200">
                +251912473927
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { toast } from "@/toast";

const store = useStore();
const router = useRouter();

const username = ref("");
const password = ref("");
const busy = ref(false);

const role = computed(() => store.getters.role);

async function onSubmit() {
  busy.value = true;
  try {
    const res = await store.dispatch("login", { username: username.value, password: password.value });
    if (!res?.ok) {
      toast.error(res?.message || "Login failed");
      return;
    }
    toast.success("Welcome back.");
    await router.push(role.value === "admin" ? "/admin/dashboard" : "/operator/entry-exit");
  } finally {
    busy.value = false;
  }
}
</script>

